/**
 * Features that are visible but not yet open.
 *
 * ONE LIST, read by the navigation AND by the router. The nav decides
 * whether the entry is tappable and the router decides what the URL
 * renders, and those are two different files — so a feature "locked" in
 * only one of them is still reachable. Here that cannot happen: an entry
 * removed from this list unlocks both at once, and an entry added locks
 * both.
 *
 * (This is the same shape as the pricing defect fixed alongside it: the
 * page said one thing and the payment path said another, because the two
 * answers came from two places that never had to agree.)
 *
 * Keyed by the route path, because that is the one identifier the nav
 * item and the <Route> already share.
 */
export const COMING_SOON = {
  "/ab-testing": {
    label: "A/B Testing",
    blurb: "Run two versions of a DM against each other and keep the one that converts.",
  },
  "/ai-writer": {
    label: "AI Writer",
    blurb: "Draft and rewrite your DM copy without leaving the builder.",
  },
};

export const COMING_SOON_PATHS = Object.keys(COMING_SOON);

export function isComingSoon(path) {
  return Object.prototype.hasOwnProperty.call(COMING_SOON, path);
}
